export const percent = (value: number, percentage: number) => {
  return (value * percentage) / 100;
};

export const annualToMonthlyIncome = (
  annualNetIncome: number | undefined,
): number | undefined =>
  annualNetIncome === undefined ? undefined : annualNetIncome / 12;
